import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '970592463142'; // without +
  const message = 'Hi, I want to get in touch with you.';
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  const buttonStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '60px',
    height: '60px',
    backgroundColor: '#25D366',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
    zIndex: 1000,
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out',
  };

  const iconStyle = {
    width: '30px',
    height: '30px',
  };

  return (
    <a href={whatsappLink} target="_blank" rel="noopener noreferrer" style={buttonStyle} aria-label="Chat on WhatsApp">
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        alt="WhatsApp"
        style={iconStyle}
      />
    </a>
  );
};

export default WhatsAppButton;
